import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'net'
})
export class NetPipe implements PipeTransform {

  constructor() {
  }

  transform(price: any, ...args: any[]): any {
    const [ vat ] = args;
    return price - ((price * (vat / 100))) / (1 + (vat / 100));
  }
}
